(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-bar')) {
    class AnnouncementBar extends HTMLElement {
      constructor() {
        super();
        this.slides = Array.from(this.querySelectorAll('.announcement-bar__message'));
        this.index = 0;
        if (this.slides.length > 0) this.slides[0].classList.add('is-active');
        const speed = Number(this.dataset.autoplay || 0);
        if (speed > 0 && this.slides.length > 1) {
          window.setInterval(() => this.next(), speed * 1000);
        }
      }
      next() {
        this.slides[this.index].classList.remove('is-active');
        this.index = (this.index + 1) % this.slides.length;
        this.slides[this.index].classList.add('is-active');
      }
    }
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-drawer-component')) {
    class CartDrawerComponent extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('dialog');

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-drawer-close]')) this.close();
          if (event.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('cancel', () => {
          document.documentElement.classList.remove('scroll-lock');
        });

        this.titleBase = this.querySelector('.cart-drawer__title')?.dataset.titleBase || '';

        document.addEventListener('cart-drawer:open', () => this.open());
        document.addEventListener('cart:updated', (event) => {
          const count = event.detail?.cart?.item_count;
          if (typeof count !== 'number') return;

          const title = this.querySelector('.cart-drawer__title');
          if (title) title.textContent = `${this.titleBase} (${count})`;

          document.querySelectorAll('.cart-icon-bubble__count').forEach((el) => {
            el.textContent = count;
            el.hidden = count === 0;
          });

          if (count > 0 && !this.dialog.open) this.open();
        });
      }

      open() {
        typeof this.dialog.showModal === 'function' ? this.dialog.showModal() : this.dialog.setAttribute('open', '');
        document.documentElement.classList.add('scroll-lock');
      }

      close() {
        this.dialog.close ? this.dialog.close() : this.dialog.removeAttribute('open');
        document.documentElement.classList.remove('scroll-lock');
      }
    }
    customElements.define('cart-drawer-component', CartDrawerComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  if (!customElements.get('facet-filters')) {
    class FacetFilters extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('[data-facets-form]');
        this.filtersPanel = this.querySelector('[data-facets-filters]');
        this.sectionId = this.dataset.sectionId;

        this.querySelector('[data-facets-toggle]')?.addEventListener('click', () => {
          this.filtersPanel?.classList.toggle('is-open');
        });

        this.addEventListener('change', (event) => {
          if (event.target.matches('input[type="checkbox"], select[data-facets-sort], input[type="number"]')) {
            this.submit();
          }
        });

        this.addEventListener('click', (event) => {
          const link = event.target.closest('.pagination a, .collection__filters-clear');
          if (link && link.href && link.href.startsWith(window.location.origin)) {
            event.preventDefault();
            this.fetchUrl(link.href);
            this.filtersPanel?.classList.remove('is-open');
          }
        });

        this.form?.addEventListener('submit', (event) => {
          event.preventDefault();
          const params = new URLSearchParams(new FormData(this.form)).toString();
          this.fetchUrl(`${this.dataset.url}?${params}`);
        });
      }

      submit() {
        const params = new URLSearchParams(new FormData(this.form)).toString();
        this.fetchUrl(`${this.dataset.url}?${params}`);
      }

      fetchUrl(url) {
        this.classList.add('is-loading');
        const target = new URL(url, window.location.origin);
        target.searchParams.set('section_id', this.sectionId);

        fetch(target.toString())
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const freshRegion = doc.querySelector('[data-facets-region]');
            const freshFilters = doc.querySelector('[data-facets-filters]');
            const freshCount = doc.querySelector('[data-facets-count]');
            if (freshRegion) this.querySelector('[data-facets-region]').innerHTML = freshRegion.innerHTML;
            if (freshFilters) this.querySelector('[data-facets-filters]').innerHTML = freshFilters.innerHTML;
            if (freshCount) this.querySelector('[data-facets-count]').innerHTML = freshCount.innerHTML;

            const cleanUrl = new URL(url, window.location.origin);
            cleanUrl.searchParams.delete('section_id');
            history.pushState({}, '', cleanUrl.toString());
            window.scrollTo({ top: this.offsetTop - 100, behavior: 'smooth' });
          })
          .finally(() => this.classList.remove('is-loading'));
      }
    }
    customElements.define('facet-filters', FacetFilters);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('site-header')) {
    class SiteHeader extends HTMLElement {
      constructor() {
        super();
        this.menuDialog = this.querySelector('#menu-drawer');
        this.searchDialog = this.querySelector('#search-dialog');
        this.cartType = this.dataset.cartType;

        this.querySelector('[data-menu-open]')?.addEventListener('click', () => this.openDialog(this.menuDialog));
        this.querySelectorAll('[data-drawer-close]').forEach((button) => {
          if (button.closest('#menu-drawer')) {
            button.addEventListener('click', () => this.closeDialog(this.menuDialog));
          }
        });
        this.menuDialog?.addEventListener('click', (event) => {
          if (event.target === this.menuDialog) this.closeDialog(this.menuDialog);
        });

        this.querySelector('[data-search-open]')?.addEventListener('click', () => {
          document.dispatchEvent(new CustomEvent('search:open'));
        });

        const cartLink = this.querySelector('[data-cart-icon-link]');
        if (cartLink && this.cartType === 'drawer') {
          cartLink.addEventListener('click', (event) => {
            event.preventDefault();
            document.dispatchEvent(new CustomEvent('cart-drawer:open'));
          });
        }

        let lastScroll = window.scrollY;
        if (this.classList.contains('header--sticky')) {
          window.addEventListener(
            'scroll',
            () => {
              const current = window.scrollY;
              this.classList.toggle('header--scrolled', current > 8);
              lastScroll = current;
            },
            { passive: true }
          );
        }

      }

      openDialog(dialog) {
        if (!dialog) return;
        typeof dialog.showModal === 'function' ? dialog.showModal() : dialog.setAttribute('open', '');
        document.documentElement.classList.add('scroll-lock');
      }

      closeDialog(dialog) {
        if (!dialog) return;
        dialog.close ? dialog.close() : dialog.removeAttribute('open');
        document.documentElement.classList.remove('scroll-lock');
      }
    }
    customElements.define('site-header', SiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('countdown-timer')) {
    class CountdownTimer extends HTMLElement {
      connectedCallback() {
        this.target = new Date(this.dataset.target).getTime();
        if (Number.isNaN(this.target)) {
          this.remove();
          return;
        }
        this.days = this.querySelector('[data-countdown-days]');
        this.hours = this.querySelector('[data-countdown-hours]');
        this.minutes = this.querySelector('[data-countdown-minutes]');
        this.seconds = this.querySelector('[data-countdown-seconds]');
        this.tick();
        this.interval = window.setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        window.clearInterval(this.interval);
      }
      tick() {
        const diff = this.target - Date.now();
        if (diff <= 0) {
          window.clearInterval(this.interval);
          this.remove();
          return;
        }
        const pad = (n) => String(n).padStart(2, '0');
        this.days.textContent = pad(Math.floor(diff / 86400000));
        this.hours.textContent = pad(Math.floor((diff / 3600000) % 24));
        this.minutes.textContent = pad(Math.floor((diff / 60000) % 60));
        this.seconds.textContent = pad(Math.floor((diff / 1000) % 60));
      }
    }
    customElements.define('countdown-timer', CountdownTimer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  if (!customElements.get('recommendations-loader')) {
    class RecommendationsLoader extends HTMLElement {
      connectedCallback() {
        const url = this.dataset.url;
        if (!url) return;
        fetch(url)
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('[data-recommendations]');
            if (fresh && fresh.innerHTML.trim() !== '') {
              this.innerHTML = fresh.innerHTML;
            } else {
              this.closest('.related-products')?.remove();
            }
          })
          .catch(() => {});
      }
    }
    customElements.define('recommendations-loader', RecommendationsLoader);
  }

  } catch(e) { console.error(e); }
})();
})();
